import { render, staticRenderFns } from "./DonutChart06.vue?vue&type=template&id=c376604e&scoped=true&"
import script from "./DonutChart06.vue?vue&type=script&lang=js&"
export * from "./DonutChart06.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c376604e",
  null
  
)

export default component.exports